import { ContractorCard } from "@/components/ContractorCard";
import { Contractor } from "@/types/contractor";

interface FeaturedContractorsProps {
  contractors: Contractor[];
}

export const FeaturedContractors = ({ contractors }: FeaturedContractorsProps) => {
  console.log('Rendering FeaturedContractors with:', contractors);
  
  // Ensure we only take exactly 3 featured contractors
  const displayContractors = contractors.slice(0, 3);
  
  // If we don't have exactly 3 featured contractors, log a warning
  if (displayContractors.length < 3) {
    console.warn(`Only ${displayContractors.length} featured contractors available. Component expects 3.`);
  }

  return (
    <div className="mb-12 px-4 md:px-6">
      <div className="space-y-4 mb-8">
        <h2 className="text-3xl font-bold text-[#174996]">Featured Contractors</h2>
        <p className="text-lg text-muted-foreground">
          Discover our top-rated professionals with proven track records of excellence
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
        {displayContractors.map((contractor) => (
          <div key={contractor.id} className="transform transition-all duration-300 hover:scale-105 h-[110%]">
            <ContractorCard
              contractor={contractor}
              viewMode="grid"
            />
          </div>
        ))}
      </div>
    </div>
  );
};